import React, { useEffect, useState } from 'react';
import CatalogService from '../services/catalog.service';
import LogoService from '../services/logo.service';
import { PlusLg, DashLg, ArrowClockwise, ArrowCounterclockwise } from 'react-bootstrap-icons';
import { Spinner, Container, Row, Col } from 'react-bootstrap';
import { set } from 'react-hook-form';
import { isLoggedIn, isSuperAdmin, getSubsite } from '../reducers/auth';
import { Button } from 'react-bootstrap';
import { resolveImageUrl } from '../utils/imageUrl';

const ImageGallery = ({ productId, selectedDecorations, forceUpdate, updateAllDecorations, updatePrice }) => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [images, setImages] = useState([]);
    const [logoPosiitonSpinner, setLogoPosiitonSpinner] = useState(false);
    const apiUrl = process.env.REACT_APP_LOCALHOST_URL;

    // All decorations for this style and color
    const [productDecorations, setProductDecorations] = useState([]);

    // All decoration image locations for this style and color
    const [decorationImageLocations, setDecorationImageLocations] = useState([]);

    // decorations that are currenly selected
    const [displayedImageLocations, setDisplayedImageLocations] = useState([]);
    const [displayedDecorations, setDisplayedDecorations] = useState([]);
    const [selectedImageLocation, setSelectedImageLocation] = useState([]);
    
    const [currentProductId, setCurrentProductId] = useState(null);

    const onColorSelect = (color) => {
        // Callback function to handle color selection
    }
    
    const  updateDisplayedLogos = (newSelectedDecoration) => {
        var price = 0;
        var newDisplayDecorations = [];
        for(var i=0; i<displayedImageLocations.length; i++) {
            if(selectedImageLocation && displayedImageLocations[i].id === newSelectedDecoration.id) {
                console.log("Adding selected logo: ", displayedImageLocations[i], newSelectedDecoration);
                newDisplayDecorations.push(newSelectedDecoration);
                price += newSelectedDecoration.decoration_logo.price;
            } else {
                console.log("Adding non selected logo: ", displayedImageLocations[i], newSelectedDecoration);
                newDisplayDecorations.push(displayedImageLocations[i]);
                price += newSelectedDecoration.decoration_logo.price;
            }
        }
        //updatePrice(price);
        //console.log("Update price: ", price);
        setDisplayedImageLocations(newDisplayDecorations);
    }

    const imageClicked = (e) => {
        // e = Mouse click event.
        var rect = e.target.getBoundingClientRect();
        var x = e.clientX - rect.left; //x position within the element.
        var y = e.clientY - rect.top;  //y position within the element.
        console.log("Left? : " + x + " ; Top? : " + y + "." + "Width" + rect.width + "Height" + rect.height);
    
        var newX = (x / rect.width) * 100;
        var newY = (y / rect.height) * 100;
    
        var newSelectedDecoration = selectedImageLocation;
        newSelectedDecoration.x = newX;
        newSelectedDecoration.y = newY;
        setSelectedImageLocation(newSelectedDecoration);
        updateDisplayedLogos(newSelectedDecoration);
    
      }
    
    const getDisplayedDecorations = (image, decoImageLocations, allDecoMap, checkSelected) => {
        // find the decorations for each position
        console.log("getDisplayedDecorations - checkSelected:", checkSelected, "selectedDecorations:", selectedDecorations?.length || 0);
        var price = 0;
        var newDisplayedDecorations = [];
        const decoLocationKeys = [...allDecoMap.keys()];
        if(checkSelected && selectedDecorations && selectedDecorations.length > 0) {
            // Only show selected decorations
            console.log("Using selected decorations mode with", selectedDecorations.length, "selected decorations");
            for(var j=0; j<selectedDecorations.length; j++) {
                var selectedDeco = selectedDecorations[j];
                console.log("Looking for decoration:", selectedDeco.decoration_logo.decorationName, "at", selectedDeco.deco_location.description, "with ID:", selectedDeco.id);

                var logos = allDecoMap.get(selectedDeco.deco_location.id);
                if (logos) {
                    for (var k = 0; k < logos.length; k++) {
                        // Match by the exact decoration ID to ensure we get the specific selected decoration
                        if (logos[k].decorationId == selectedDeco.id) {
                            newDisplayedDecorations.push(logos[k]);
                            console.log("Added selected decoration by ID match:", selectedDeco.decoration_logo.decorationName, "at", selectedDeco.deco_location.description);
                            break; // Found the exact match, no need to continue
                        }
                        // Fallback to the old matching logic if ID match fails
                        else if (logos[k].decorationLogoId == selectedDeco.decoration_logo.id &&
                                 logos[k].decoLocationId == selectedDeco.deco_location.id) {
                            newDisplayedDecorations.push(logos[k]);
                            console.log("Added selected decoration by legacy match:", selectedDeco.decoration_logo.decorationName, "at", selectedDeco.deco_location.description);
                            break; // Take only the first match to avoid duplicates
                        }
                    }
                } else {
                    console.log("No logos found for location:", selectedDeco.deco_location.description);
                }
            }
        } else {
            // No selected decorations - show nothing (let ProductDetails handle default selection)
            console.log("No selected decorations - showing nothing");
        }

        // Match up a image location for each decoration
        var newDisplayDecorations = [];
        for (var i = 0; i < newDisplayedDecorations.length; i++) {
            for (var j = 0; j < decoImageLocations.length; j++) {
                const decoration = decoImageLocations[j];
                if (decoration.decorationLogoId == newDisplayedDecorations[i].decorationLogoId &&
                    decoration.decoLocationId == newDisplayedDecorations[i].decoLocationId &&
                    decoration.imageUrl === image.imageUrl) {

                    newDisplayDecorations.push(decoration);
                    //console.log("New Logo Price: ", decoration.decoration_logo.price);
                    price += decoration.decoration_logo.price;
                }
            }
        }
        //console.log("New Logo Price: ", price);
        //updatePrice(price);

        console.log("getDisplayedDecorations returning:", newDisplayDecorations.length, "decorations");
        return newDisplayDecorations;
    };

    const handleImageClick = (image) => {
        setSelectedImage(image);

        setDisplayedImageLocations(getDisplayedDecorations(image, decorationImageLocations, productDecorations, true));
    };

/*    useEffect(() => {
        if(!currentProductId || currentProductId !== productId) {
            console.log("COMPONENT LOADED", productId);
            setCurrentProductId(productId);
            const fetchImages = async () => {
                const images = await CatalogService.getImagesForStyleAndColor(productId);
                if (images.images && images.images.length > 0) {
                    // Set the first image as the selected image
                    setSelectedImage(images.images[0]);
                    // Save the images to state
                    setImages(images.images);
                    var allDecoMap = new Map();
                    console.log("All Decorations: ", images.allDecorations);
                    for (var i = 0; i < images.allDecorations.length; i++) {
                        var currentArray = allDecoMap.get(images.allDecorations[i].decoLocationId);
                        if (currentArray) {
                            currentArray.push(images.allDecorations[i]);
                            allDecoMap.set(images.allDecorations[i].decoLocationId, currentArray);
                        } else {
                            allDecoMap.set(images.allDecorations[i].decoLocationId, [images.allDecorations[i]]);
                        }
                    }
                    setProductDecorations(allDecoMap);
                    setDecorationImageLocations(images.decorationImageLocations || []);
                    updateAllDecorations(images.allDecorations);
                    setDisplayedImageLocations(getDisplayedDecorations(images.images[0], images.decorationImageLocations, allDecoMap, true));

                } else {
                    console.error("No images found for productId:", productId);
                }
            }
            fetchImages();
        }
    }, []);
*/
/*    useEffect(() => {
        console.log("FORCE UPDATE");
        const fetchImages = async () => {
            const images = await CatalogService.getImagesForStyleAndColor(productId);
            if (images.images && images.images.length > 0) {
                // Set the first image as the selected image
                setSelectedImage(images.images[0]);
                // Save the images to state
                setImages(images.images);
                var allDecoMap = new Map();
                console.log("All Decorations: ", images.allDecorations);
                for (var i = 0; i < images.allDecorations.length; i++) {
                    var currentArray = allDecoMap.get(images.allDecorations[i].decoLocationId);
                    if (currentArray) {
                        currentArray.push(images.allDecorations[i]);
                        allDecoMap.set(images.allDecorations[i].decoLocationId, currentArray);
                    } else {
                        allDecoMap.set(images.allDecorations[i].decoLocationId, [images.allDecorations[i]]);
                    }
                }
                setProductDecorations(allDecoMap);
                setDecorationImageLocations(images.decorationImageLocations || []);
                updateAllDecorations(images.allDecorations);
                setDisplayedImageLocations(getDisplayedDecorations(images.images[0], images.decorationImageLocations, allDecoMap, true));

            } else {
                console.error("No images found for productId:", productId);
            }
        }
        fetchImages();
    }, [forceUpdate]);
*/
    useEffect(() => {
        console.log("SELECTED IMAGE CHANGED");
        const fetchImages = async () => {
            setDisplayedImageLocations(getDisplayedDecorations(selectedImage, decorationImageLocations, productDecorations, true));
            // set selectedImageLocation(selectedDecoration);
        }

        fetchImages();
    }, [selectedImage, selectedDecorations]);

    useEffect(() => {
        console.log("PRODUCT ID CHANGED", productId);

        const fetchImages = async () => {
            const images = await CatalogService.getImagesForStyleAndColor(productId);
            if (images.images && images.images.length > 0) {
                // Set the first image as the selected image
                setSelectedImage(images.images[0]);
                // Save the images to state
                setImages(images.images);
                var allDecoMap = new Map();
                for (var i = 0; i < images.allDecorations.length; i++) {
                    console.log("Current Array: ", images.allDecorations.length);
                    var currentArray = allDecoMap.get(images.allDecorations[i].decoLocationId);
                    if (currentArray) {
                        currentArray.push(images.allDecorations[i]);
                        allDecoMap.set(images.allDecorations[i].decoLocationId, currentArray);
                    } else {
                        allDecoMap.set(images.allDecorations[i].decoLocationId, [images.allDecorations[i]]);
                    }
                }
                setProductDecorations(allDecoMap);

                setDecorationImageLocations(images.decorationImageLocations || []);

                // Always reset selection when color/product changes since different products have different logos
                console.log("Product/color changed, clearing selection and setting new defaults");
                updateAllDecorations(images.allDecorations);

                // Don't call setDisplayedImageLocations here - let the selectedDecorations useEffect handle it
                // after the state has been updated by updateAllDecorations

            } else {
                console.error("No images found for productId:", productId);
            }
        }
        // Fetch images when the component mounts
        if (productId) {
            fetchImages();
        }
    }, [productId]);

    return (
        <div className="image-gallery">
            <div className="main-image">
                <div style={{ display: "inline-block", position: "relative" }}>
                    <img className="bg-image" src={resolveImageUrl(selectedImage?.imageUrl)} width={'100%'} alt={selectedImage?.alt} onClick={imageClicked} />
                    {displayedImageLocations && displayedImageLocations.map((logo, i) => {
                    return <img className="logo-image" src={apiUrl + logo.decoration_logo.imageUrl} width={logo.width + '%'} style={{ left: logo.x + '%', top: logo.y + '%', transform: 'rotate(' + logo.rotate + 'deg)' }}></img>
                    })
                    }
                </div>
            </div>
            <div style={{ fontSize: 12 }}>Please note that all items are custom created and decorated. We make every effort to ensure that images match the final product. All logos, locations, and colors are approximate and may not represent the final product based on decoration restrictions. We reserve the right to modify the images and decoration guidelines at any time and as necessary.</div>
            <div className="thumbnail-list">
                {images.map((image, index) => (
                    <div style={{ display: "inline-block" }}
                        key={index}

                        onClick={() => handleImageClick(image)}
                    >
                        <img height={100} src={resolveImageUrl(image?.imageUrl)} alt={image.alt} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ImageGallery;